import { jsxs as t, jsx as o } from "react/jsx-runtime";
const n = ({ className: r }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M8.3335 11.8019C8.45152 11.9952 8.59156 12.1781 8.75363 12.3468C9.75989 13.394 11.2936 13.5577 12.4648 12.8379C12.6818 12.7045 12.8864 12.5408 13.0728 12.3468L15.7723 9.53727C16.965 8.29595 16.965 6.28338 15.7723 5.04207C14.5796 3.80075 12.6458 3.80076 11.4531 5.04207L10.8585 5.6609",
          stroke: "currentColor",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M9.14208 15.8944L8.54726 16.5135C7.35454 17.7548 5.42076 17.7548 4.22804 16.5135C3.03532 15.2721 3.03532 13.2596 4.22804 12.0183L6.92755 9.20876C8.12027 7.96744 10.0541 7.96744 11.2468 9.20876C11.4088 9.37738 11.5488 9.56025 11.6668 9.75347",
          stroke: "currentColor",
          strokeLinecap: "round"
        }
      )
    ]
  }
);
export {
  n as CopyLinkIcon
};
